import {
  LayoutDashboard,
  Users,
  Car,
  Boxes,
  ShoppingCart,
  ClipboardList,
  CalendarDays,
  FileText,
  DollarSign,
  CreditCard,
  Wrench,
  ShieldCheck,
  Building2,
  Settings,
  HardDrive,
  MessageCircle,
  AlertTriangle,
  LucideIcon,
} from "lucide-react";

export type NavigationLink = {
  href: string;
  label: string;
  icon?: LucideIcon;
};

export type NavigationGroup = {
  label: string;
  icon?: LucideIcon;
  children: NavigationLink[];
};

export type NavigationItem = NavigationLink | NavigationGroup;

export const isNavigationGroup = (
  item: NavigationItem,
): item is NavigationGroup => "children" in item;

export const baseNavigation: NavigationItem[] = [
  { href: "/", label: "Dashboard", icon: LayoutDashboard },
  {
    label: "Cadastro",
    icon: Users,
    children: [
      { href: "/cadastro/clientes", label: "Clientes", icon: Users },
      { href: "/cadastro/veiculos", label: "Veículos", icon: Car },
      { href: "/cadastro/veiculos/montadoras", label: "Montadoras", icon: Car },
      { href: "/cadastro/veiculos/modelos", label: "Modelos", icon: Car },
      { href: "/cadastro/produtos", label: "Produtos", icon: Boxes },
      {
        href: "/cadastro/fornecedores",
        label: "Fornecedores",
        icon: ShoppingCart,
      },
      { href: "/cadastro/servicos", label: "Serviços", icon: ClipboardList },
      { href: "/cadastro/pistas", label: "Pistas", icon: Wrench },
    ],
  },
  {
    label: "Serviços",
    icon: ClipboardList,
    children: [
      { href: "/orcamentos", label: "Orçamentos", icon: FileText },
      { href: "/ordens", label: "Ordens de serviço", icon: ClipboardList },
      {
        href: "/servicos/agenda",
        label: "Agenda de serviços",
        icon: CalendarDays,
      },
      { href: "/servicos/veiculos", label: "Veículos", icon: Car },
      { href: "/pistas", label: "Pistas / Boxes", icon: Wrench },
      { href: "/whatsapp", label: "WhatsApp", icon: MessageCircle },
      { href: "/entrada-veiculo", label: "Entrada de veículo", icon: Car },
      {
        href: "/entrada-veiculo/checklists",
        label: "Checklists de entrada",
        icon: ClipboardList,
      },
      {
        href: "/avaliacoes-tecnicas",
        label: "Avaliações técnicas",
        icon: ClipboardList,
      },
      {
        href: "/pre-orcamentos",
        label: "Pré-orçamentos",
        icon: ShoppingCart,
      },
    ],
  },
  {
    label: "Financeiro",
    icon: DollarSign,
    children: [
      { href: "/financeiro/pagar", label: "Contas a Pagar", icon: DollarSign },
      {
        href: "/financeiro/receber",
        label: "Contas a Receber",
        icon: CreditCard,
      },
      {
        href: "/financeiro/nfse",
        label: "Notas Fiscais (NFS-e)",
        icon: FileText,
      },
    ],
  },
  {
    label: "Relatórios",
    icon: FileText,
    children: [
      { href: "/relatorios", label: "Painel", icon: FileText },
      { href: "/relatorios/clientes", label: "Clientes", icon: Users },
      { href: "/relatorios/veiculos", label: "Veículos", icon: Car },
      {
        href: "/relatorios/servicos",
        label: "Intervalo de serviços",
        icon: CalendarDays,
      },
      {
        href: "/relatorios/manutencao",
        label: "Retorno de manutenção",
        icon: Wrench,
      },
      {
        href: "/migracao-millenium",
        label: "Pendências Millenium",
        icon: AlertTriangle,
      },
    ],
  },
];

export const adminNavigation: NavigationGroup = {
  label: "Admin da Empresa",
  icon: ShieldCheck,
  children: [
    { href: "/admin-empresa", label: "Visão geral", icon: LayoutDashboard },
    { href: "/admin-empresa/empresa", label: "Empresa", icon: Building2 },
    { href: "/admin-empresa/usuarios", label: "Usuários", icon: Users },
    {
      href: "/admin-empresa/configuracoes",
      label: "Configurações",
      icon: Settings,
    },
    {
      href: "/admin-empresa/certificados",
      label: "Certificados NFS-e",
      icon: ShieldCheck,
    },
    {
      href: "/admin-empresa/integracoes/telegram",
      label: "Integrações Telegram",
      icon: MessageCircle,
    },
  ],
};

export const adminGlobalNavigation: NavigationGroup = {
  label: "Admin Global",
  icon: ShieldCheck,
  children: [
    { href: "/admin-global", label: "Visão geral", icon: LayoutDashboard },
    { href: "/admin-global/empresas", label: "Empresas", icon: Building2 },
    {
      href: "/admin-global/configuracoes",
      label: "Configurações",
      icon: Settings,
    },
    { href: "/admin-global/papeis", label: "Papéis", icon: ShieldCheck },
    {
      href: "/admin-global/permissoes",
      label: "Permissões",
      icon: ShieldCheck,
    },
    {
      href: "/admin-global/backup",
      label: "Backup do Sistema",
      icon: HardDrive,
    },
    { href: "/admin-global/logs", label: "Auditoria", icon: FileText },
    { href: "/admin-global/migracao-millenium", label: "Importação Millenium", icon: HardDrive },
  ],
};
